import { useEffect, useRef } from 'react'
import { targetComponents } from 'site/Renderer/components/SelectAndLink/SelectAndLink.constants'
import type { SelectAndLinkSession } from 'site/Renderer/components/SelectAndLink/SelectAndLink.types'
import { applySelectAndLinkValuesToGroupedFieldValues } from 'site/Renderer/components/SelectAndLink/utils/applySelectAndLinkValuesToGroupedFieldValues'
import { GroupedFieldValues } from '../../../types'

type HandleChange = (
  action: { type: 'set'; payload: GroupedFieldValues } | null
) => void

export type UseSyncFieldsValuesAfterSelectAndLinkParams = {
  selectAndLinkSession: SelectAndLinkSession | null
  groupedFieldValues: GroupedFieldValues
  handleChange: HandleChange
  closeSelectAndLink: () => void
  onClearSelection: () => void
}

const useSyncFieldsValuesAfterSelectAndLink = ({
  selectAndLinkSession,
  groupedFieldValues,
  handleChange,
  closeSelectAndLink,
  onClearSelection
}: UseSyncFieldsValuesAfterSelectAndLinkParams): void => {
  const hasAppliedRef = useRef(false)

  useEffect(() => {
    const targetGroup = selectAndLinkSession?.targetGroup
    const targetField = selectAndLinkSession?.targetField
    const selectedOptions = selectAndLinkSession?.selectedOptions
    const isSessionCompleted = selectAndLinkSession?.isCompleted

    if (
      isSessionCompleted &&
      !hasAppliedRef.current &&
      selectAndLinkSession?.targetComponent ===
        targetComponents.FILTER_FIELDS &&
      targetGroup &&
      targetField &&
      Array.isArray(selectedOptions)
    ) {
      hasAppliedRef.current = true
      const nextGroupedFieldValues =
        applySelectAndLinkValuesToGroupedFieldValues(
          groupedFieldValues,
          targetGroup,
          targetField,
          selectedOptions
        )

      handleChange({
        type: 'set',
        payload: nextGroupedFieldValues
      })

      onClearSelection()
      closeSelectAndLink()
    }
    if (!isSessionCompleted) {
      hasAppliedRef.current = false
    }
  }, [
    selectAndLinkSession,
    groupedFieldValues,
    handleChange,
    closeSelectAndLink,
    onClearSelection
  ])
}

export default useSyncFieldsValuesAfterSelectAndLink
